/**
 * Trigger: tr_account_transfers_update
 * Purpose: Update account balances when account transfer details change
 * Table: account_transfers
 * Event: UPDATE OF account_in_id, account_out_id, currency_id, transfer_date, amount
 */
export const TR_ACCOUNT_TRANSFERS_UPDATE = `
CREATE TRIGGER tr_account_transfers_update
UPDATE OF account_in_id, account_out_id, currency_id, transfer_date, amount ON account_transfers
BEGIN
  UPDATE account_balances
  SET transfers_amount = transfers_amount + old.amount
  WHERE account_id = old.account_out_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount + old.amount
  WHERE account_id = old.account_out_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  UPDATE account_balances
  SET transfers_amount = transfers_amount - old.amount
  WHERE account_id = old.account_in_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount - old.amount
  WHERE account_id = old.account_in_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_out_id, new.currency_id, new.transfer_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_out_id, new.transfer_date);

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_in_id, new.currency_id, new.transfer_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_in_id, new.transfer_date);

  UPDATE account_balances
  SET transfers_amount = transfers_amount - new.amount
  WHERE account_id = new.account_out_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount - new.amount
  WHERE account_id = new.account_out_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date;

  UPDATE account_balances
  SET transfers_amount = transfers_amount + new.amount
  WHERE account_id = new.account_in_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET transfers_amount = transfers_amount + new.amount
  WHERE account_id = new.account_in_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_out_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_in_id
    AND account_id != old.account_out_id
    AND currency_id = old.currency_id
    AND balance_date = old.transfer_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_out_id
    AND account_id != old.account_out_id
    AND account_id != old.account_in_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_in_id
    AND account_id != old.account_out_id
    AND account_id != old.account_in_id
    AND account_id != new.account_out_id
    AND currency_id = new.currency_id
    AND balance_date = new.transfer_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_out_id
    AND activity_date = old.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = old.account_out_id
        AND balance_date = old.transfer_date
    );

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_in_id
    AND account_id != old.account_out_id
    AND activity_date = old.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = old.account_in_id
        AND balance_date = old.transfer_date
    );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_out_id
    AND account_id != old.account_out_id
    AND account_id != old.account_in_id
    AND activity_date = new.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = new.account_out_id
        AND balance_date = new.transfer_date
    );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_in_id
    AND account_id != old.account_out_id
    AND account_id != old.account_in_id
    AND account_id != new.account_out_id
    AND activity_date = new.transfer_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = new.account_in_id
        AND balance_date = new.transfer_date
    );
END;
`;
